import React from 'react';
export const CFIconArrowCornerRightUp = {
    alias: 'arrow-corner-right-up',
    defaultTitle: 'Arrow Corner Right Up',
    source: ({ Path }) => (React.createElement(React.Fragment, null,
        React.createElement(Path, { d: 'm18.625 8.219-5-4a1 1 0 0 0-1.249 0l-5 4a1 1 0 0 0 1.249 1.562L12 7.08V16c0 .551-.448 1-1 1H6a1 1 0 0 0 0 2h5c1.655 0 3-1.346 3-3V7.08l3.376 2.701a.998.998 0 0 0 1.405-.157.999.999 0 0 0-.156-1.405Z' }))),
};
